import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@icon/plus.svg'


const _hoisted_1 = { class: "to-do-assign__wrapper" }
const _hoisted_2 = { class: "to-do__plus" }
const _hoisted_3 = {
  key: 0,
  class: "error-text error-text-small"
}
const _hoisted_4 = {
  key: 0,
  class: "to-do-assign__created-by"
}
const _hoisted_5 = { class: "to-do-assign__created-by__user" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_AvatarGroupToDo = _resolveComponent("AvatarGroupToDo")!
  const _component_icon = _resolveComponent("icon")!
  const _component_TeamMemberSelect = _resolveComponent("TeamMemberSelect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Field, {
      as: "div",
      name: "toDoOwner",
      rules: _ctx.rules,
      modelValue: !!_ctx.selectedUsers?.length,
      validateOnBlur: false,
      class: "to-do-assign__owner"
    }, {
      default: _withCtx(({ errors }) => [
        _createVNode(_component_BaseSubHeading, {
          size: "large",
          weight: "400",
          color: errors[0] ? 'serviceAlert-02' : 'monochrome-06',
          class: "to-do-assign__owner__heading"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Assigned to: ")
          ]),
          _: 2
        }, 1032, ["color"]),
        _createVNode(_component_TeamMemberSelect, {
          id: "to-do-assign",
          users: _ctx.users,
          teams: _ctx.searchedTeams,
          selectedUsers: _ctx.selectedUsers,
          selectedTeams: _ctx.selectedTeams,
          selectedTeamList: _ctx.selectedTeamList,
          allowTeamSelection: !_ctx.toDo.disableSelectionTeam,
          searchText: _ctx.filterUsers.text,
          isLast: _ctx.isLast,
          className: "to-do-assign",
          popperClass: "to-do-assign__dropdown",
          onSelectUser: _ctx.onUpdateSelectedList,
          onSelectTeam: _ctx.onSelectTeam,
          onRemoveUser: _ctx.onRemoveUser,
          onToggleList: _ctx.toggleList,
          onSearch: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSearchUsers({ value: $event }))),
          onScroll: _ctx.onScroll
        }, {
          label: _withCtx(({ selectedUsers: users, removeUser }) => [
            _createVNode(_component_AvatarGroupToDo, {
              avatars: users,
              numberOfVisibleUsers: 5,
              showRemoveButton: true,
              scaleByHover: true,
              type: "avatarGroup",
              size: "md",
              onOnRemoveAvatar: removeUser
            }, null, 8, ["avatars", "onOnRemoveAvatar"]),
            _withDirectives(_createElementVNode("button", _hoisted_2, [
              _createVNode(_component_icon, {
                data: _imports_0,
                fill: true,
                width: "var(--icon-16)",
                height: "var(--icon-16)",
                class: "to-do__plus-icon"
              })
            ], 512), [
              [_vShow, users?.length]
            ])
          ]),
          _: 1
        }, 8, ["users", "teams", "selectedUsers", "selectedTeams", "selectedTeamList", "allowTeamSelection", "searchText", "isLast", "onSelectUser", "onSelectTeam", "onRemoveUser", "onToggleList", "onScroll"]),
        (errors[0])
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " required "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rules", "modelValue"]),
    (_ctx.createdBy.id && _ctx.currentUser.id !== _ctx.createdBy.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_BaseSubHeading, {
            size: "large",
            weight: "400",
            color: "monochrome-05",
            darkColor: "monochrome-03"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" From: ")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Avatar, {
              src: _ctx.createdBy.pictureUrl ?? null,
              gap: _ctx.createdBy.getInitials(),
              bordered: ""
            }, null, 8, ["src", "gap"]),
            _createVNode(_component_BaseSubHeading, {
              size: "large",
              weight: "500",
              color: "monochrome-06"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.createdBy.username), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}